import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleLoadingComponent } from '../../utils/apollo';

import AvailabilityCalendar from './availability-calendar';

const query = gql`
  query AvailabilityCalendar($fromDate: OrdinalDate!, $toDate: OrdinalDate!) {
    viewer {
      id
      enabledFeatures
      repVisitsEvents(fromDate: $fromDate, toDate: $toDate) {
        id
        collegeFairId
        timezone
        dayId
        appointmentId
        date
        startISOTime
        endISOTime
        userBookingStatus
        chosenVisitLocationType
        highSchool {
          id
          name
        }
      }
      heAccount {
        id
        freemium
        activeSubscriptions
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ fromDate, toDate }) => ({
    variables: {
      fromDate,
      toDate,
    },
    fetchPolicy: 'cache-and-network',
  }),
});

export default SimpleLoadingComponent(graphqlData)(AvailabilityCalendar);
